import React, { useEffect, useRef, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Fixed } from 'layouts';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Switch,
  FormControlLabel,
  Tooltip,
  Radio,
  Checkbox,
  ListItemText,
  FormLabel,
  FormGroup,
  Card,
  Typography,
  TextField,
  OutlinedInput,
  Chip,
  Modal,
  InputAdornment,
  CircularProgress,
  Icon,
  Divider,
  DialogContentText,
  RadioGroup,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Menu,
  Tabs,
  Tab,
  Autocomplete,
} from '@mui/material';
import moment from 'moment';
import {
  Add,
  AddCircle,
  Close,
  CloudDownload,
  CopyAll,
  Delete,
  DeleteOutline,
  Description,
  Edit,
  EditOutlined,
  ExpandMore,
  Group,
  Link,
  Lock,
  Mic,
  MoreVert,
  Notes,
  Redo,
  Replay,
  Send,
  StopCircle,
} from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import getAllVideoDataPoints from 'redux/actions/Common/getAllVideoDataPoints';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import getPlatformConfigs from 'redux/actions/Common/getPlatformConfigs';
import updatePlatformConfigs from 'redux/actions/Common/updatePlatformConfigs';
import getPineconeIndices from 'redux/actions/Common/getPineconeIndices';
import getDocumentNamespaces from 'redux/actions/Common/getDocumentNamespaces';
import AiResponseSections from './components/AiResponseSections';
import RiskBandsConfig from './components/RiskBandsConfig';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const defaultLabels = [
  'clarity',
  'pace',
  'fluency',
  'confidence',
  'enthusiasm',
  'delivery',
  'content',
];

const GlobalConfigs = () => {
  const theme = useTheme();
  const history = useHistory();
  const dispatch = useDispatch();
  const { pathname, state } = useLocation();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  const isXs = useMediaQuery(theme.breakpoints.only('xs'), {
    defaultMatches: true,
  });
  const isSm = useMediaQuery(theme.breakpoints.only('sm'), {
    defaultMatches: true,
  });
  const chatsScrollview = useRef(null);

  const [platformConfigs, setPlatformConfigs] = useState(null);

  const [addValuePropToRag, setAddValuePropToRag] = useState(false);
  const [enableEnrichLayer, setEnableEnrichLayer] = useState(false);
  const [
    enableEnrichLayerForWorkExperienceSearchForLlmResults,
    setEnableEnrichLayerForWorkExperienceSearchForLlmResults,
  ] = useState(false);
  const [
    showStackholderProfilePosts,
    setShowStackholderProfilePosts,
  ] = useState(false);

  const [pineconeIndices, setPineconeIndices] = useState(null);
  const [selectedAdminRagIndex, setSelectedAdminRagIndex] = useState(null);

  const [orgAccountResearchIndex, setOrgAccountResearchIndex] = useState(null);
  const [orgArtifactIndex, setOrgArtifactIndex] = useState(null);
  const [orgDocumentsIndex, setOrgDocumentsIndex] = useState(null);
  const [selectedOrgRagIndex, setSelectedOrgRagIndex] = useState(null);

  const [documentNamespaces, setDocumentNamespaces] = useState([]);
  const [selectedNamespace, setSelectedNamespace] = useState(null);

  const [emailService, setEmailService] = useState(null);
  const [activeConfigurationTab, setActiveConfigurationTab] = useState(
    'sendgrid',
  );
  const [imapEmail, setImapEmail] = useState(null);
  const [imapPassword, setImapPassword] = useState(null);
  const [testImapEmail, setTestImapEmail] = useState(null);
  const [testImapPassword, setTestImapPassword] = useState(null);
  const [testMode, setTestMode] = useState(false);
  const [testEmails, setTestEmails] = useState([]);
  const [testEmailInput, setTestEmailInput] = useState('');

  useEffect(() => {
    if (platformConfigs) {
      setEmailService(platformConfigs.emailService || 'sendgrid');
      setActiveConfigurationTab(platformConfigs.emailService || 'sendgrid');
      setImapEmail(platformConfigs?.imapEmail || '');
      setImapPassword(platformConfigs?.customFields?.imapPassword || '');
      setTestImapEmail(platformConfigs?.testImapEmail || '');
      setTestImapPassword(
        platformConfigs?.customFields?.testImapPassword || '',
      );
      setTestMode(platformConfigs?.testMode || false);
      setTestEmails(platformConfigs?.testEmails || []);
    }
  }, [platformConfigs]);

  useEffect(() => {
    if (
      platformConfigs &&
      pineconeIndices &&
      pineconeIndices?.length > 0 &&
      documentNamespaces &&
      documentNamespaces?.length > 0
    ) {
      setAddValuePropToRag(platformConfigs.addValuePropToRag || false);
      setEnableEnrichLayer(platformConfigs.enableEnrichLayer || false);
      setEnableEnrichLayerForWorkExperienceSearchForLlmResults(
        platformConfigs.enableEnrichLayerForWorkExperienceSearchForLlmResults ||
          false,
      );
      setShowStackholderProfilePosts(
        platformConfigs.showStackholderProfilePosts || false,
      );
      setSelectedOrgRagIndex(
        pineconeIndices?.find((indice) =>
          platformConfigs?.orgDocumentRagIndexDtls?.indexName
            ? indice?.name ===
              platformConfigs?.orgDocumentRagIndexDtls?.indexName
            : process.env.REACT_APP_TARGET_ENV === 'local' ||
              process.env.REACT_APP_TARGET_ENV === 'development'
            ? indice?.name === 'dev-doc-template-exp-v1'
            : indice?.name === 'prod-doc-template-exp-v1',
        ) || null,
      );
      setOrgAccountResearchIndex(
        pineconeIndices?.find((indice) =>
          platformConfigs?.orgAccountResearchIndex?.indexName
            ? indice?.name ===
              platformConfigs?.orgAccountResearchIndex?.indexName
            : process.env.REACT_APP_TARGET_ENV === 'local' ||
              process.env.REACT_APP_TARGET_ENV === 'development'
            ? indice?.name === 'dev-doc-template-exp-v1'
            : indice?.name === 'prod-doc-template-exp-v1',
        ) || null,
      );
      setOrgArtifactIndex(
        pineconeIndices?.find((indice) =>
          platformConfigs?.orgArtifactIndex?.indexName
            ? indice?.name === platformConfigs?.orgArtifactIndex?.indexName
            : process.env.REACT_APP_TARGET_ENV === 'local' ||
              process.env.REACT_APP_TARGET_ENV === 'development'
            ? indice?.name === 'dev-doc-template-exp-v1'
            : indice?.name === 'prod-doc-template-exp-v1',
        ) || null,
      );
      setOrgDocumentsIndex(
        pineconeIndices?.find((indice) =>
          platformConfigs?.orgDocumentsIndex?.indexName
            ? indice?.name === platformConfigs?.orgDocumentsIndex?.indexName
            : process.env.REACT_APP_TARGET_ENV === 'local' ||
              process.env.REACT_APP_TARGET_ENV === 'development'
            ? indice?.name === 'dev-doc-template-exp-v1'
            : indice?.name === 'prod-doc-template-exp-v1',
        ) || null,
      );
      setSelectedAdminRagIndex(
        pineconeIndices?.find((indice) =>
          platformConfigs?.adminDocumentTemplateRagIndexDtls?.indexName
            ? indice?.name ===
              platformConfigs?.adminDocumentTemplateRagIndexDtls?.indexName
            : process.env.REACT_APP_TARGET_ENV === 'local' ||
              process.env.REACT_APP_TARGET_ENV === 'development'
            ? indice?.name === 'dev-doc-template-exp-v1'
            : indice?.name === 'prod-doc-template-exp-v1',
        ) || null,
      );
      setSelectedNamespace(
        documentNamespaces?.find((ns) =>
          platformConfigs?.adminDocumentTemplateRagIndexDtls?.namespace
            ? platformConfigs?.adminDocumentTemplateRagIndexDtls?.namespace ===
              ns
            : documentNamespaces?.[0],
        ),
      );
    }
  }, [platformConfigs, pineconeIndices, documentNamespaces]);

  const refreshPlatformConfigs = () => {
    dispatch(
      getPlatformConfigs((data) => {
        console.log(data);
        setPlatformConfigs(data);
      }),
    );
  };

  useEffect(() => {
    refreshPlatformConfigs();
    dispatch(
      getPineconeIndices((indices) => {
        setPineconeIndices(indices || []);
      }),
    );
    dispatch(
      getDocumentNamespaces((namespaces) => {
        setDocumentNamespaces(namespaces);
      }),
    );
  }, []);

  console.log(selectedAdminRagIndex);
  console.log(selectedOrgRagIndex);
  console.log(selectedNamespace);

  return (
    <Fixed>
      <Box
        width={{ xs: '100vw', sm: '100vw', md: 'calc(100vw - 266px)' }}
        height={{
          xs: 'calc(100vh - 60px)',
          sm: 'calc(100vh - 70px)',
          md: 'calc(100vh - 80px)',
        }}
        sx={{
          overflow: 'hidden',
        }}
        display={'flex'}
        flexDirection={{ xs: 'column', md: 'column' }}
        position={'relative'}
        gap={1}
      >
        <Box
          display={'flex'}
          flexDirection={{ xs: 'column', sm: 'column', md: 'row' }}
          padding={2}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              border: '1px solid #d3d3d3',
              borderRadius: 2,
              padding: 2,
              width: 1,
              height: 1,
              minHeight: 'calc(100vh - 100px)',
              maxHeight: 'calc(100vh - 100px)',
              overflowY: 'scroll',
              '&::-webkit-scrollbar': {
                width: '5px',
              },
              '&::-webkit-scrollbar-track': {
                boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: theme.palette.primary.main,
                borderRadius: 2,
              },
            }}
          >
            <Typography>Update Platform Global Configurations</Typography>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={enableEnrichLayer}
                  name="enableEnrichLayer"
                />
              }
              label={
                <Typography variant="subtitle2">Enable Enrich Layer</Typography>
              }
              onChange={(e) => {
                dispatch(
                  updatePlatformConfigs(
                    {
                      enableEnrichLayer: e.target.checked,
                    },
                    () => {
                      dispatch(
                        getPlatformConfigs((data) => {
                          console.log(data);
                          setPlatformConfigs(data);
                        }),
                      );
                    },
                  ),
                );
              }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={
                    enableEnrichLayerForWorkExperienceSearchForLlmResults
                  }
                  name="enableEnrichLayerForWorkExperienceSearchForLlmResults"
                />
              }
              label={
                <Typography variant="subtitle2">
                  Enable Enrich Layer for Work Experience Search for LLM Results
                </Typography>
              }
              onChange={(e) => {
                dispatch(
                  updatePlatformConfigs(
                    {
                      enableEnrichLayerForWorkExperienceSearchForLlmResults:
                        e.target.checked,
                    },
                    () => {
                      dispatch(
                        getPlatformConfigs((data) => {
                          console.log(data);
                          setPlatformConfigs(data);
                        }),
                      );
                    },
                  ),
                );
              }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={addValuePropToRag}
                  name="addValuePropToRag"
                />
              }
              label={
                <Typography variant="subtitle2">
                  Include Value Prop in Doc Creation / RAG chat
                </Typography>
              }
              onChange={(e) => {
                dispatch(
                  updatePlatformConfigs(
                    {
                      addValuePropToRag: e.target.checked,
                    },
                    () => {
                      dispatch(
                        getPlatformConfigs((data) => {
                          console.log(data);
                          setPlatformConfigs(data);
                        }),
                      );
                    },
                  ),
                );
              }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={showStackholderProfilePosts}
                  name="showStackholderProfilePosts"
                />
              }
              label={
                <Typography variant="subtitle2">
                  Show Stakeholder Profile and Posts
                </Typography>
              }
              onChange={(e) => {
                dispatch(
                  updatePlatformConfigs(
                    {
                      showStackholderProfilePosts: e.target.checked,
                    },
                    () => {
                      dispatch(
                        getPlatformConfigs((data) => {
                          console.log(data);
                          setPlatformConfigs(data);
                        }),
                      );
                    },
                  ),
                );
              }}
            />
            <Divider orientation="horizontal" flexItem />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                border: '1px solid #d3d3d3',
                borderRadius: 2,
                padding: 2,
              }}
            >
              <Box sx={{}}>
                <Typography>Admin Rag</Typography>
                <Box display={'flex'} gap={2}>
                  <FormControl variant="outlined" sx={{ flex: 1 }} size="small">
                    <FormLabel id="ragIndex">Pinecone Index</FormLabel>
                    <Select
                      labelId="ragindex-select-label"
                      value={selectedAdminRagIndex}
                      onChange={(e) => {
                        setSelectedAdminRagIndex(e.target.value);
                      }}
                    >
                      {pineconeIndices && pineconeIndices.length > 0
                        ? pineconeIndices.map((indice) => (
                            <MenuItem value={indice}>{indice.name}</MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>
                  <FormControl variant="outlined" sx={{ flex: 1 }} size="small">
                    <FormLabel id="selectednamespace">
                      Select Namespace
                    </FormLabel>
                    <Select
                      labelId="selectednamespace-select-label"
                      value={selectedNamespace || ''}
                      onChange={(e) => {
                        setSelectedNamespace(e.target.value);
                      }}
                    >
                      {documentNamespaces && documentNamespaces.length > 0
                        ? documentNamespaces.map((namespace) => (
                            <MenuItem value={namespace}>{namespace}</MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>
                </Box>
              </Box>
              <Box sx={{}}>
                <Typography>Org Rag</Typography>
                <Box display={'flex'} gap={2}>
                  <FormControl variant="outlined" sx={{ flex: 1 }} size="small">
                    <FormLabel id="orgAccountResearchIndex">
                      Org Account Research Index
                    </FormLabel>
                    <Select
                      labelId="orgAccountResearchIndex-select-label"
                      value={orgAccountResearchIndex}
                      onChange={(e) => {
                        setOrgAccountResearchIndex(e.target.value);
                      }}
                    >
                      {pineconeIndices && pineconeIndices.length > 0
                        ? pineconeIndices.map((indice) => (
                            <MenuItem value={indice}>{indice.name}</MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>
                </Box>
                <Box display={'flex'} gap={2}>
                  <FormControl variant="outlined" sx={{ flex: 1 }} size="small">
                    <FormLabel id="orgArtifactIndex">
                      Org Artifact Index
                    </FormLabel>
                    <Select
                      labelId="orgArtifactIndex-select-label"
                      value={orgArtifactIndex}
                      onChange={(e) => {
                        setOrgArtifactIndex(e.target.value);
                      }}
                    >
                      {pineconeIndices && pineconeIndices.length > 0
                        ? pineconeIndices.map((indice) => (
                            <MenuItem value={indice}>{indice.name}</MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>
                </Box>
                <Box display={'flex'} gap={2}>
                  <FormControl variant="outlined" sx={{ flex: 1 }} size="small">
                    <FormLabel id="orgDocumentsIndex">
                      Org Documents Index
                    </FormLabel>
                    <Select
                      labelId="orgDocumentsIndex-select-label"
                      value={orgDocumentsIndex}
                      onChange={(e) => {
                        setOrgDocumentsIndex(e.target.value);
                      }}
                    >
                      {pineconeIndices && pineconeIndices.length > 0
                        ? pineconeIndices.map((indice) => (
                            <MenuItem value={indice}>{indice.name}</MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => {
                    dispatch(
                      updatePlatformConfigs(
                        {
                          adminDocumentTemplateRagIndexDtls: {
                            indexHost: selectedAdminRagIndex?.host,
                            indexName: selectedAdminRagIndex?.name,
                            namespace: selectedNamespace,
                          },
                          // orgDocumentRagIndexDtls: {
                          //   indexHost: selectedOrgRagIndex?.host,
                          //   indexName: selectedOrgRagIndex?.name,
                          // },
                          orgAccountResearchIndex: {
                            indexHost: orgAccountResearchIndex?.host,
                            indexName: orgAccountResearchIndex?.name,
                          },
                          orgArtifactIndex: {
                            indexHost: orgArtifactIndex?.host,
                            indexName: orgArtifactIndex?.name,
                          },
                          orgDocumentsIndex: {
                            indexHost: orgDocumentsIndex?.host,
                            indexName: orgDocumentsIndex?.name,
                          },
                        },
                        () => {
                          alert('Information Updated');
                          dispatch(
                            getPlatformConfigs((data) => {
                              console.log(data);
                              setPlatformConfigs(data);
                            }),
                          );
                        },
                      ),
                    );
                  }}
                >
                  Update
                </Button>
              </Box>
            </Box>
            <Divider orientation="horizontal" flexItem />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                border: '1px solid #d3d3d3',
                borderRadius: 2,
                padding: 2,
              }}
            >
              <Box sx={{}}>
                {/* <Typography>Email Service Configuration</Typography> */}
                <Box display={'flex'} flexDirection={'column'} gap={1}>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'start',
                    }}
                  >
                    <Box display="flex" flexDirection="column" gap={0.5}>
                      <FormLabel>Email Service</FormLabel>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Typography
                          variant="body2"
                          color={
                            emailService === 'sendgrid'
                              ? 'text.primary'
                              : 'text.secondary'
                          }
                        >
                          SendGrid
                        </Typography>
                        <Switch
                          checked={emailService === 'imap'}
                          onChange={(e) =>
                            setEmailService(
                              e.target.checked ? 'imap' : 'sendgrid',
                            )
                          }
                        />
                        <Typography
                          variant="body2"
                          color={
                            emailService === 'imap'
                              ? 'text.primary'
                              : 'text.secondary'
                          }
                        >
                          IMAP
                        </Typography>
                      </Box>
                    </Box>
                    <Button
                      variant="contained"
                      size="small"
                      disabled={
                        emailService === 'imap'
                          ? !imapEmail ||
                            !imapPassword ||
                            !testImapEmail ||
                            !testImapPassword
                          : false
                      }
                      onClick={() => {
                        dispatch(
                          updatePlatformConfigs(
                            {
                              emailService,
                              imapEmail,
                              imapPassword,
                              testImapEmail,
                              testImapPassword,
                              testMode,
                              testEmails,
                            },
                            () => {
                              alert('Information Updated');
                              dispatch(
                                getPlatformConfigs((data) => {
                                  console.log(data);
                                  setPlatformConfigs(data);
                                }),
                              );
                            },
                          ),
                        );
                      }}
                    >
                      Update
                    </Button>
                  </Box>
                  <Box
                    sx={{
                      border: '1px solid #d3d3d3',
                      borderRadius: 2,
                    }}
                  >
                    <Tabs
                      value={activeConfigurationTab}
                      onChange={(_, val) => setActiveConfigurationTab(val)}
                      size="small"
                      sx={{
                        borderBottom: '1px solid #d3d3d3',
                      }}
                    >
                      <Tab label="SendGrid Configuration" value="sendgrid" />
                      <Tab label="IMAP Configuration" value="imap" />
                    </Tabs>
                    {activeConfigurationTab === 'imap' ? (
                      <Box
                        display={'flex'}
                        flexDirection={'column'}
                        gap={2}
                        padding={2}
                        minHeight={300}
                      >
                        <Typography>
                          IMAP Configuration (will be used by real prod users)
                        </Typography>
                        <Box display={'flex'} gap={2}>
                          <TextField
                            label="IMAP Email"
                            variant="outlined"
                            name={'imapEmail'}
                            size="small"
                            fullWidth
                            value={imapEmail}
                            onChange={(e) => setImapEmail(e.target.value)}
                          />
                          <TextField
                            label="IMAP Password"
                            variant="outlined"
                            name={'imapPassword'}
                            size="small"
                            fullWidth
                            value={imapPassword}
                            onChange={(e) => setImapPassword(e.target.value)}
                          />
                        </Box>
                        <Typography>
                          IMAP Test Configuration (will be used by internal test
                          accounts)
                        </Typography>
                        <Box display={'flex'} gap={2}>
                          <TextField
                            label="IMAP Test Email"
                            variant="outlined"
                            name={'testImapEmail'}
                            size="small"
                            fullWidth
                            value={testImapEmail}
                            onChange={(e) => setTestImapEmail(e.target.value)}
                          />
                          <TextField
                            label="IMAP Test Password"
                            variant="outlined"
                            name={'testImapPassword'}
                            size="small"
                            fullWidth
                            value={testImapPassword}
                            onChange={(e) =>
                              setTestImapPassword(e.target.value)
                            }
                          />
                        </Box>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={testMode}
                              onChange={(e) => setTestMode(e.target.checked)}
                            />
                          }
                          label="Enable Test Mode"
                        />
                        {testMode && (
                          <Box
                            display={'flex'}
                            flexDirection={'column'}
                            gap={1}
                          >
                            <Autocomplete
                              multiple
                              freeSolo
                              options={[]}
                              value={testEmails}
                              inputValue={testEmailInput}
                              onChange={(_, newValue) =>
                                setTestEmails(newValue)
                              }
                              onInputChange={(_, newInputValue) =>
                                setTestEmailInput(newInputValue)
                              }
                              onKeyDown={(e) => {
                                if (
                                  (e.key === 'Enter' || e.key === 'Tab') &&
                                  testEmailInput.trim()
                                ) {
                                  e.preventDefault();
                                  setTestEmails((prev) => [
                                    ...prev,
                                    testEmailInput.trim(),
                                  ]);
                                  setTestEmailInput('');
                                }
                              }}
                              renderTags={(value, getTagProps) =>
                                value.map((email, idx) => (
                                  <Chip
                                    label={email}
                                    size="small"
                                    {...getTagProps({ index: idx })}
                                    key={idx}
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Test Emails"
                                  variant="outlined"
                                  size="small"
                                  placeholder="Type and press Enter or Tab to add"
                                />
                              )}
                            />
                          </Box>
                        )}
                      </Box>
                    ) : (
                      <Box
                        display={'flex'}
                        flexDirection={'column'}
                        gap={2}
                        padding={2}
                        minHeight={300}
                      >
                        <Typography>No configuration available yet.</Typography>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
            <Divider orientation="horizontal" flexItem />
            <AiResponseSections
              platformConfigs={platformConfigs}
              onUpdated={refreshPlatformConfigs}
            />
            <Divider orientation="horizontal" flexItem />
            <RiskBandsConfig
              platformConfigs={platformConfigs}
              onUpdated={refreshPlatformConfigs}
            />
          </Box>
        </Box>
      </Box>
    </Fixed>
  );
};

export default GlobalConfigs;
